import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Collapse, Glyphicon, Well } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import routes from 'src/routing/routes'
import withStyles from 'react-jss'
import styles from './Region.styles'
import Titre5 from 'src/components/font/Titre5'
import { getUrlValueFromValue } from 'src/utils'

class Region extends Component {
  state = {
    show: false
  }

  clickHandler = () => {
    this.setState({ show: !this.state.show })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.category !== this.props.category && prevState.show) {
      this.setState({ show: false })
    }
  }

  render() {
    const { classes, nomRegion, codeRegion, listeDeps, category } = this.props
    const linkCategory = getUrlValueFromValue(category)

    return (
      <div className={classes.regionBlock}>
        <span onClick={this.clickHandler} className={classes.menuElement}>
          <Titre5 className={classes.inlineTitle}>{nomRegion}</Titre5>
          <Glyphicon
            glyph={this.state.show ? 'chevron-up' : 'chevron-down'}
            className={classes.glyph}
          />
        </span>

        <Collapse in={this.state.show}>
          <Well className={classes.well}>
            <div className={classes.itemCollapsed}>
              <Link
                to={routes.mapRegion
                  .replace(':category', linkCategory)
                  .replace(':inseeRegion', codeRegion)
                  .replace(':page', '1')}
              >
                <strong>{nomRegion}</strong>
              </Link>
            </div>
            {listeDeps &&
              listeDeps.length > 0 &&
              listeDeps.map((dep, i) => (
                <div key={i} className={classes.itemCollapsed}>
                  <Link
                    to={routes.mapDepartment
                      .replace(':category', linkCategory)
                      .replace(':inseeDepartment', dep.inseeCode)
                      .replace(':page', '1')}
                  >
                    {dep.name}
                  </Link>
                </div>
              ))}
          </Well>
        </Collapse>
      </div>
    )
  }
}

Region.propTypes = {
  listeDeps: PropTypes.array,
  nomRegion: PropTypes.string.isRequired
}

export default withStyles(styles)(Region)
